export function toFullUrl(shortUrl: string) {
  const el = document.createElement('a')
  el.href = shortUrl
  return el.href
}
